// extracted by mini-css-extract-plugin
export default {"iconWrapper":"styles_iconWrapper__eV3Xv","tags":"styles_tags__fHaVc","documentIcon":"styles_documentIcon__xBBkA"};